/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createPickRandom } from '../../factoriesAny.js';
export var pickRandomDependencies = {
  typedDependencies: typedDependencies,
  createPickRandom: createPickRandom
};